import type { FareCode } from "@silversea-ssc/web-fares";
import { farePriority } from "@silversea-ssc/web-fares";
import { isPresent } from "../../utils/checks";

export const fareByPriority = (a: FareCode, b: FareCode) =>
  farePriority[a] - farePriority[b];

export const fareContentByFareCodes = <
  T extends { fareCodes?: (string | undefined)[] }
>(
  fareContents: (T | undefined)[] | undefined,
  fareCode: FareCode
): T | undefined =>
  (fareContents || []).filter(isPresent).find(withFareCode(fareCode));

const isD2DFareCode = (fareCode: FareCode) => fareCode == "DoorToDoorV2";
const isPlusFareCode = (fareCode: FareCode) => fareCode == "Plus";
export const isTopChoice = (fareCode: FareCode) =>
  isD2DFareCode(fareCode) || isPlusFareCode(fareCode);

const withFareCode =
  <T extends { fareCodes?: (string | undefined)[] | (FareCode | undefined)[] }>(
    fareCode: FareCode
  ) =>
  (object: T): boolean => {
    return (object.fareCodes || []).includes(fareCode);
  };
